(function () {
  "use strict";

  var VERSION = "1.0";
  var STORAGE_KEY = "xtra_attribution_v1";
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var MAX_VALUE_LENGTH = 220;
  var TOUCH_FIELDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_id",
    "utm_campaign_id",
    "utm_adgroup_id",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid"
  ];
  var CLICK_FIELDS = ["gclid", "gbraid", "wbraid", "fbclid", "fbc", "fbp"];

  function clean(value, maxLength) {
    if (value === null || value === undefined) return "";
    return String(value)
      .replace(/[\u0000-\u001f\u007f]/g, "")
      .trim()
      .slice(0, maxLength || MAX_VALUE_LENGTH);
  }

  function readCookie(name) {
    try {
      var prefix = name + "=";
      var parts = document.cookie ? document.cookie.split(";") : [];
      for (var index = 0; index < parts.length; index += 1) {
        var value = parts[index].trim();
        if (value.indexOf(prefix) === 0) {
          return clean(decodeURIComponent(value.slice(prefix.length)));
        }
      }
    } catch (_error) {
      return "";
    }
    return "";
  }

  function externalReferrerHost() {
    if (!document.referrer) return "";
    try {
      var referrer = new URL(document.referrer);
      if (referrer.hostname === window.location.hostname) return "";
      return clean(referrer.hostname, 120);
    } catch (_error) {
      return "";
    }
  }

  function detectChannel(touch) {
    var source = clean(touch.utm_source).toLowerCase();
    if (touch.gclid || touch.gbraid || touch.wbraid || source === "google") return "google";
    if (
      touch.fbclid ||
      touch.fbc ||
      source === "meta" ||
      source === "facebook" ||
      source === "instagram" ||
      source === "fb" ||
      source === "ig"
    ) {
      return "meta";
    }
    return source || "other";
  }

  function collectTouch() {
    var params = new URLSearchParams(window.location.search || "");
    var touch = {
      captured_at: new Date().toISOString(),
      landing_path: clean(window.location.pathname || "/", 180),
      referrer_host: externalReferrerHost()
    };
    var hasAttributionParameter = false;
    TOUCH_FIELDS.forEach(function (field) {
      var value = clean(params.get(field));
      if (value) {
        touch[field] = value;
        hasAttributionParameter = true;
      }
    });

    touch.fbc = readCookie("_fbc");
    touch.fbp = readCookie("_fbp");
    touch.channel = detectChannel(touch);

    if (!hasAttributionParameter && !touch.referrer_host) return null;
    return touch;
  }

  function loadState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var state = JSON.parse(raw);
      if (!state || state.version !== VERSION || Number(state.expires_at || 0) <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return state;
    } catch (_error) {
      return null;
    }
  }

  function saveState(state) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_error) {
      return;
    }
  }

  function mergeState(current) {
    var state = loadState() || {
      version: VERSION,
      first: null,
      last: null,
      channels: [],
      expires_at: Date.now() + TTL_MS
    };
    if (current) {
      if (!state.first) state.first = current;
      state.last = current;
      if ((current.channel === "meta" || current.channel === "google") && state.channels.indexOf(current.channel) < 0) {
        state.channels.push(current.channel);
      }
      state.expires_at = Date.now() + TTL_MS;
      saveState(state);
    }
    return state.first || state.last ? state : null;
  }

  function addTouchAttributes(attributes, prefix, touch) {
    if (!touch) return;
    var fields = [
      "captured_at",
      "channel",
      "landing_path",
      "referrer_host",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "utm_id",
      "utm_campaign_id",
      "utm_adgroup_id"
    ].concat(CLICK_FIELDS);
    fields.forEach(function (field) {
      var value = clean(touch[field]);
      if (value) attributes["xtra_" + prefix + "_" + field] = value;
    });
  }

  function buildAttributes(state) {
    var attributes = {
      xtra_attr_version: VERSION,
      xtra_seen_meta: state.channels.indexOf("meta") >= 0 ? "true" : "false",
      xtra_seen_google: state.channels.indexOf("google") >= 0 ? "true" : "false",
      xtra_touch_channels: clean(state.channels.join(","), 40)
    };
    addTouchAttributes(attributes, "first", state.first);
    addTouchAttributes(attributes, "last", state.last);
    return attributes;
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === "function") {
        return privacy.marketingAllowed();
      }
    } catch (_error) {
      return false;
    }
    return true;
  }

  function cartRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function attributesDiffer(current, desired) {
    var existing = current || {};
    return Object.keys(desired).some(function (key) {
      return clean(existing[key]) !== clean(desired[key]);
    });
  }

  function syncCartAttributes(attributes) {
    var root = cartRoot();
    return window
      .fetch(root + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("cart_read_failed");
        return response.json();
      })
      .then(function (cart) {
        if (!attributesDiffer(cart.attributes, attributes)) return null;
        return window.fetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function (response) {
        if (response && !response.ok) throw new Error("cart_update_failed");
      })
      .catch(function () {
        return null;
      });
  }

  function run() {
    if (!marketingAllowed()) return;
    var state = mergeState(collectTouch());
    if (!state) return;
    syncCartAttributes(buildAttributes(state));
  }

  function schedule() {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(run, { timeout: 1500 });
    } else {
      window.setTimeout(run, 0);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener("pageshow", schedule);
  document.addEventListener("visitorConsentCollected", schedule);
})();
